<template>
  <img :src="customer.customerLogoLink" alt="logo" height="46" />
</template>

<script>
import { CUSTOMER } from "@/environment/env.customer";

export default {
  name: "Logo",
  computed: {
    customer() {
      return CUSTOMER;
    },
  },
  props: {
    custom_class: {
      type: String,
      default: function () {
        return "text-lg-left mb-4";
      },
    },
  },
};
</script>
